import { lazy, Suspense } from 'react'
import styled from 'styled-components'
import { Link } from 'react-router-dom'

import { colors } from 'utils/colors'
import { Button, Spinner } from 'components'
import withNavigationBar from 'hoc/nav-bar/with-navigation-bar'
import { ROUTES } from '../../constants/constants'
const PageNotFoundSvg = lazy(() => import('assets/page-not-found.svg'))

const PageNotFound: React.ComponentType<JSX.IntrinsicAttributes & { isTokenPresent: boolean }> = ({
  isTokenPresent,
}) => (
  <Container isTokenPresent={isTokenPresent}>
    <Suspense fallback={<Spinner fontSize={80} />}>
      <PageNotFoundSvg />
    </Suspense>
    <Title>
      <Orange>Oops!</Orange> Page not found
    </Title>
    <Subtitle>We’re sorry, the page you requested could not be found.</Subtitle>
    <StyledLink to={`/${ROUTES.DASHBOARD}`}>
      <Button variant="outline" marginTop="16px">
        Back to home
      </Button>
    </StyledLink>
  </Container>
)

const Title = styled.div`
  ${(p) => p.theme.font({ family: 'montserrat', size: 34, weight: 'bold' })}
  padding-bottom: 10px;
  text-align: center;
`

const Orange = styled.span`
  color: ${(p) => p.theme.colors.orange};
`

const Subtitle = styled.div`
  ${(p) => p.theme.font({ size: 20, color: 'gray7' })}
  text-align: center;
`

const Container = styled.div<{ isTokenPresent: boolean }>`
  background-color: ${colors.gray2};
  height: ${(p) => (p.isTokenPresent ? 'calc(100vh - 60px)' : '100vh')};
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  overflow: hidden;
`

const StyledLink = styled(Link)`
  text-decoration: none;
  color: ${colors.blue1};
`

export { PageNotFound as PageNotFoundWithoutNavBar }

export default withNavigationBar(PageNotFound)
